// extracted by mini-css-extract-plugin
export default {"wrap":"_w-z","fullWidth":"ax-z","searchPlacement":"bx-z","items":"cx-z","featureCss":"dx-z","disabled":"ex-z","imgCss":"fx-z"};